import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useLenisContext } from '@providers/LenisProvider';

export const useScrollToTopPathname = () => {
  const { pathname } = useLocation();
  const lenisRef = useLenisContext();

  useEffect(() => {
    if (!lenisRef?.current) return;

    lenisRef.current.scrollTo(0, { immediate: true });
  }, [pathname, lenisRef]);
};
